import { ReactNode } from "react";

interface Props {
  children?: ReactNode;
}

export function MonoText({ children }: Props) {
  return <span className="contents font-mono text-sm">{children}</span>;
}
